export function formatDate(value: Date | null, locale = "de-DE"): string {
  if (!value) return "—";
  return new Intl.DateTimeFormat(locale, {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(value);
}

export function humanizeRole(role: string | null): string {
  if (!role) return "—";

  switch (role) {
    case "OWNER":
      return "Inhaber";
    case "ADMIN":
      return "Admin";
    case "WORKER":
      return "Mitarbeiter";
    default:
      return role;
  }
}
